import { render, staticRenderFns } from "./SidebarAdminPage.vue?vue&type=template&id=4cf40db8&scoped=true&"
import script from "./SidebarAdminPage.vue?vue&type=script&lang=js&"
export * from "./SidebarAdminPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf40db8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cf40db8')) {
      api.createRecord('4cf40db8', component.options)
    } else {
      api.reload('4cf40db8', component.options)
    }
    module.hot.accept("./SidebarAdminPage.vue?vue&type=template&id=4cf40db8&scoped=true&", function () {
      api.rerender('4cf40db8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Sidebar/AdminPage/SidebarAdminPage.vue"
export default component.exports